module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.16.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@9.39.4_jiti@1.21_27c7db5fac240a10df9d8c6ceb25daa7/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"./src/images/icon.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0b308e106d4c2c9d8f9260af6c477912"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@9.39.4_jiti@1.21.7___react-dom@18.3.1_react@18_b00f26c6d2f70e13e013ee0083aa9dce/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
